import FormActions from '../../logic/form-actions';
import FormType from '../../constants/form-type';
import LoginComponent from '../login-component';
import EmailInput from '../form-components/email-input';
import PasswordInput from '../form-components/password-input';
import ForgotPasswordLink from '../form-components/forgot-password-link';
import KeepLoggedInCheckbox from '../form-components/keep-logged-in-checkbox';
import LoginFormHeader from '../form-components/form-header';
import LoginSubmitButton from '../form-components/login-submit-button';
import {localize} from '../../infrastructure/localization';

import './login.scss';

export default class Login extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render () {
        const subTitle = this.isPromo ? '' : (
            <div className="subtitle-text">
                <span>{localize('forms.login.change-or')}</span>
                &nbsp;
                <a href="javascript:void(0)" onClick={() => FormActions.changeFormType(this.state.componentId, FormType.register)}>
                    {localize('forms.login.change-link')}
                </a>
            </div>
        );

        return (
            <div className="forms-login">
                <LoginFormHeader componentId={this.state.componentId} title={localize('forms.login.title')} subTitle={subTitle} />

                <form className="login-form-content"
                      noValidate="true"
                      onSubmit={(e) => {e.preventDefault(); FormActions.login(this.state.componentId)}}>

                    <EmailInput componentId={this.state.componentId} />

                    <PasswordInput componentId={this.state.componentId} />

                    <ForgotPasswordLink componentId={this.state.componentId} />

                    <KeepLoggedInCheckbox componentId={this.state.componentId} />

                    <LoginSubmitButton componentId={this.state.componentId} />
                </form>
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/forms/login.jsx
 **/